// extracted by mini-css-extract-plugin
module.exports = {"container":"PopularProducts_container__19wqw","typo_popular":"PopularProducts_typo_popular__131q0"};